import type {
  SearchLegPlace,
  SearchParams,
} from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export const getOriginFromFirstLeg = (
  userSearch: Pick<SearchParams, 'legs'>,
): SearchLegPlace | undefined => userSearch.legs?.[0]?.origin || undefined;

export const getDestinationFromFirstLeg = (
  userSearch: Pick<SearchParams, 'legs'>,
): SearchLegPlace | undefined => userSearch.legs?.[0]?.destination || undefined;
